import { render, staticRenderFns } from "./TrainerEdit.vue?vue&type=template&id=37430d28&scoped=true"
import script from "./TrainerEdit.vue?vue&type=script&lang=js"
export * from "./TrainerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37430d28",
  null
  
)

export default component.exports